import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { InputLabel, Select, Input } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { GET_SITES } from '../../queries/site';

export const SitesInput = ({ form: { form }, sitesData: { sitesData }, onChange: sitesChange }) => {
  const { data, loading, error } = useQuery(GET_SITES);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  let sortedSites = [];
  if (data) {
    sortedSites = [...data.findAllBySystem].sort((a, b) => {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    });
  }

  const handleChange = (e) => {
    if (sitesChange) {
      sitesChange(e.target.value);
    }
  };

  return (
    <>
      {
        form.getFieldDecorator('sites',
          {
            initialValue: (sitesData || ''),
          })(
            <>
              <InputLabel style={{ fontSize: 12, marginTop: 15 }}>Sites</InputLabel>
              <Select
                labelId="sites-mutiple"
                id="sites-lookup-id"
                multiple
                value={sitesData}
                onChange={handleChange}
                input={<Input />}
                style={{ width: '100%' }}
              >
                {
                  sortedSites.map(item => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))
                }
              </Select>
            </>,
        )
      }
    </>
  );
};
